import React from 'react';

interface Props {
  fillColor: string;
}

const StoolWater = ({ fillColor }: Props) => {
  return (
    <svg width='29' height='17' viewBox='0 0 29 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.9181 0.000121719C13.3021 -0.0128367 10.5344 1.00929 7.27442 2.87518C3.89995 4.8066 1.23787 4.10734 0.27155 7.53003C-1.69294 14.4882 7.4384 15.9599 13.5887 16.2921C20.3931 16.6597 27.6265 15.0599 28.8578 10.542C30.089 6.02405 23.0923 0.0222478 16.9181 0.000121719Z'
        fill={fillColor}
      />
    </svg>
  );
};

export default StoolWater;
